import { memo } from 'react';

import { Empty, Flex, Typography } from 'antd';

function EmptyPlaceholder({ description = 'No data' }) {
  return (
    <Flex className="w-full h-full" align="center" justify="center">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        styles={{ image: { height: 60 } }}
        description={<Typography.Text type="secondary">{description}</Typography.Text>}
      />
    </Flex>
  );
}

export default memo(EmptyPlaceholder);
